export class FlightGenerated {
    compyIataCode: string;
    oriIataCode: string;
    destIataCode: string;
    dttmFlight: string;
    numFlight: number;
    reportType: string;
}